<template>
    <TooltipProvider>
        <SidebarProvider>
            <div class="!block">
                <Sidebar
                    :class="'!block h-full w-full border-cinder-900 bg-cinder-900 text-white transition-all duration-300'"
                >
                    <SidebarHeader class="!block">
                        <OrganizationSwitcher :sidebar-open="sidebarOpen" />
                    </SidebarHeader>

                    <SidebarContent class="pl-1">
                        <NavMain :items="navMain" :sidebar-open="sidebarOpen" @close-sidebar="emit('close-sidebar')" />
                    </SidebarContent>

                    <SidebarFooter>
                        <SidebarUsage :sidebar-open="sidebarOpen" />
                        <div class="mx-1">
                            <NavUser :sidebar-open="sidebarOpen" />
                        </div>
                    </SidebarFooter>
                </Sidebar>
            </div>
        </SidebarProvider>
    </TooltipProvider>
</template>

<script setup>
import { computed } from 'vue'
import Sidebar from '@/components/ui/sidebar/Sidebar.vue'
import { defineEmits } from 'vue'
import SidebarContent from '@/components/ui/sidebar/SidebarContent.vue'
import SidebarFooter from '@/components/ui/sidebar/SidebarFooter.vue'
import SidebarHeader from '@/components/ui/sidebar/SidebarHeader.vue'

import OrganizationSwitcher from './navigation/OrganizationSwitcher.vue'
import NavMain from './navigation/NavMain.vue'
import NavUser from './navigation/NavUser.vue'
import SidebarUsage from './navigation/SidebarUsage.vue'
import SidebarProvider from '@/components/ui/sidebar/SidebarProvider.vue'
import TooltipProvider from '@/components/ui/tooltip/TooltipProvider.vue'

const props = defineProps({
    sidebarOpen: Boolean,
})
const emit = defineEmits(['close-sidebar'])

const navMain = computed(() => [
    {
        title: 'AI Agent',
        url: 'ai-chat',
        icon: 'comments',
        permission: 'module.chatbot',
        paths: ['text-slate-500', 'text-slate-400'],
        isActive: true,
    },
    {
        title: 'Discovery',
        url: 'discovery',
        icon: 'magnifying-glass',
        permission: 'module.discovery',
        paths: ['text-slate-400', 'text-slate-500'],
        isActive: true,
    },
    {
        title: 'Industries',
        url: 'industries',
        icon: 'chart-line',
        permission: 'admin.access',
        paths: ['text-slate-400', 'text-slate-500'],
    },
    {
        title: 'Campaigns',
        url: 'campaigns',
        icon: 'sparkles',
        permission: 'module.campaigns',
        paths: ['text-slate-500', 'text-slate-400'],
    },
    {
        title: 'Lists',
        url: 'lists',
        icon: 'list',
        permission: 'module.lists',
        paths: ['text-slate-400', 'text-slate-500'],
    },
    {
        title: 'Reports',
        url: 'reports',
        icon: 'chart-line',
        permission: 'module.reports',
        paths: ['text-slate-400', 'text-slate-500'],
    },
    {
        title: 'Messages',
        url: 'messages',
        icon: 'envelope',
        permissions: ['module.messages', 'feature.messages.integration'],
        paths: ['text-slate-500', 'text-slate-400'],
    },
])
</script>
